<template>
  <div class="container-fluid"  >

    <div class="row col-12"  v-if="images && images.length>0" >
      <div class="col-12 col-md-4"   v-for="(image,image_index) in images" :key="image_index">
        <a href="javascript:void();" @click="$emit('clickImage',image)"
            ><div class="userpage-img-container">
          <v-lazy-image :src="resize_image(image.url,320)" sizes="(max-width: 320px) 320px,
            (max-width: 640px) 640px,
            (max-width: 960px) 960px,
            1000px"  :srcset="getSrcset(image.url)" class="userpage-img-fit"/>
          <div class="userpage-img-title">
            <h4 v-if="image.caption && image.caption.length>0" v-html="image.caption"></h4>
            <h4 v-if="!(image.caption && image.caption.length>0)">Изображение</h4>

          </div>
        </div></a>
      </div>

    </div>


  </div>
</template>

<script>
import Api from "../../models/Api";
import VLazyImage from "v-lazy-image/v2";
export default {
  name: "CardGallery",
  props: ["images"],
  components: {
    VLazyImage
  },
  data(){
    return {

    }
  },
  methods: {
    getSrcset(url){
      var app=this;
      var result=app.resize_image(url,320)+' 320w,'+app.resize_image(url,640)+' 640w,'+app.resize_image(url,960)+' 960w,'+url+' 1000w';
      return result;
    },
    resize_image(path,width){
      return Api.resize_image(path,width);
    },
  },
  mounted(){
    var app=this;


  }
}
</script>

<style scoped>

</style>